import { IVendedor } from "app/types/IVendedor";
import { BaseApi } from "./BaseApi";


export class PessoaApi extends BaseApi {

    async listarVendedoresPorNome(nome:string): Promise<IVendedor[]> {
      const resposta = await this.api.get(`/Pessoa/ListarVendedoresPorNome`,  {
      params: {
        nome
    }})

      return resposta.data
    }
  } 